import Vue from 'vue'
import Vuex from 'vuex'
import * as getters from './getters'
import * as actions from './actions'
import * as mutations from './mutations'

Vue.use(Vuex)

const state = {

	settings: JSON.parse(localStorage.getItem('shiseido-settings')) || {},
	token: localStorage.getItem('shiseido-token') || null,

	dashboard: '',

	// shiseido db options
	options: {
		brands: [],
		distributionChannel: [],
		area: [],
		country: [],
		storeType: [],
		storeLevel: [],
		openRefurbish: [],
		personalizationType: [],
		furnitureType: [],
		projectStatus: [],
		projectType: [],
		fullyLoaded: false
	},

	// shiseido db of projects
	projects: {},
	notifications: [],
	notificationsToken: null,
	indexes: [],
	projectsFile: ''
}

const store = new Vuex.Store({
	state,
	getters,
	actions,
	mutations
})

// hot reload
if (module.hot) {
	module.hot.accept([
		'./getters',
		'./actions',
		'./mutations'
	], () => {
		store.hotUpdate({
			getters: require('./getters'),
			actions: require('./actions'),
			mutations: require('./mutations')
		})
	})
}

export default store



// WEBPACK FOOTER //
// ./src/store/index.js